<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{
          facilityType.title("ＱＲコード発行対象一覧")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- 編集ダイアログ -->
        <v-dialog v-model="dialog" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!screen.readOnly"
              v-bind="attrs"
              v-on="on"
              @click="registerItem"
              class="mx-2"
              color="primary"
              >「新規登録」はこのボタンを押してください</v-btn
            >
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form">
                <v-container fluid>
                  <v-row v-if="type === 'SC'">
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        v-model="editedItem.year"
                        :rules="[
                          rules.required,
                          rules.numberCheck,
                          rules.yearCheck
                        ]"
                        label="年度"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        counter="4"
                        maxlength="4"
                        outlined
                        clearable
                        @input="judgeRegisterInfo"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="type === 'SC'">
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        v-model="editedItem.sch_year"
                        :rules="[rules.required, rules.numberCheck]"
                        label="学年"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        counter="2"
                        maxlength="2"
                        outlined
                        clearable
                        @input="judgeRegisterInfo"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        v-model="editedItem.sch_cls"
                        :rules="[rules.required, rules.alphanumericCheck]"
                        label="組"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        counter="2"
                        maxlength="2"
                        outlined
                        clearable
                        @input="judgeRegisterInfo"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        v-model="editedItem.att_num"
                        :rules="[rules.required, rules.numberCheck]"
                        label="出席番号"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        counter="3"
                        maxlength="3"
                        outlined
                        clearable
                        @input="judgeRegisterInfo"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        v-model="editedItem.name_kanji"
                        :rules="[rules.required]"
                        label="氏名"
                        :placeholder="config.PLACEHOLDER_NAME"
                        counter="64"
                        maxlength="64"
                        outlined
                        clearable
                        @input="judgeRegisterInfo"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col v-if="type === 'SC'" cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        v-model="editedItem.name_kana"
                        :rules="[rules.required]"
                        label="氏名カナ"
                        :placeholder="config.PLACEHOLDER_KANA_NAME"
                        counter="64"
                        maxlength="64"
                        outlined
                        clearable
                        @input="judgeRegisterInfo"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      v-if="type === 'VU' || type === 'SU'"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                    >
                      <v-text-field
                        v-model="editedItem.name_kana"
                        label="氏名カナ"
                        :placeholder="config.PLACEHOLDER_KANA_NAME"
                        counter="64"
                        maxlength="64"
                        outlined
                        clearable
                        @input="judgeRegisterInfo"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      v-if="type === 'VU' || type === 'SU'"
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="editedItem.address"
                        label="現住所"
                        :placeholder="config.PLACEHOLDER_ADDRESS"
                        counter="128"
                        maxlength="128"
                        append-icon="mdi-magnify"
                        clearable
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="type === 'VU' || type === 'SU'">
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="editedItem.birthday"
                        label="生年月日"
                        :placeholder="config.PLACEHOLDER_BIRTH"
                        counter="10"
                        maxlength="10"
                        :rules="[rules.birthdayCheck]"
                        append-icon="mdi-magnify"
                        clearable
                        outlined
                        @input="judgeRegisterInfo"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="editedItem.sex"
                        :items="[...sexDates]"
                        label="性別"
                        item-text="sex_text"
                        item-value="sex_id"
                        :placeholder="config.PLACEHOLDER_SELECT"
                        clearable
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="type === 'VU' || type === 'SU'">
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="editedItem.iodine_possession"
                        :items="[...iodinePossessionDates]"
                        label="安定ヨウ素剤所持状況"
                        item-text="iodinePossession_text"
                        item-value="iodinePossession_id"
                        :placeholder="config.PLACEHOLDER_SELECT"
                        clearable
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="type === 'VU' || type === 'SU'">
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="editedItem.pregrancy_possibility"
                        :items="[...pregrancyPossibilityDates]"
                        label="妊娠有無"
                        item-text="pregrancyPossibility_text"
                        item-value="pregrancyPossibility_id"
                        :placeholder="config.PLACEHOLDER_SELECT"
                        clearable
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="type === 'VU' || type === 'SU'">
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="editedItem.required_consideration"
                        label="要配慮の理由"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        counter="30"
                        maxlength="30"
                        append-icon="mdi-magnify"
                        clearable
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.remarks"
                        label="備考"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        counter="100"
                        maxlength="100"
                        outlined
                        clearable
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="cantSaveFlag"
                class="mx-2"
                color="primary"
                @click="save"
              >
                {{ saveBtnText }}
              </v-btn>
              <v-btn class="mx-2" color="primary" @click="closeEdit">
                キャンセル
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- 削除ダイアログ -->
        <v-dialog v-model="dialogDelete" persistent max-width="400">
          <v-card>
            <v-card-title></v-card-title>
            <v-card-text
              >QRコードを削除しますが、よろしいでしょうか？
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mx-2" color="primary" @click="openDeleteConfirm">
                削除
              </v-btn>
              <v-btn class="mx-2" color="primary" @click="closeDelete">
                キャンセル
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeleteConfirm" persistent max-width="400">
          <v-card>
            <v-card-title></v-card-title>
            <v-card-text
              >削除した場合には元に戻せません。本当によろしいですか？
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mx-2" color="primary" @click="deleteItem">
                削除
              </v-btn>
              <v-btn class="mx-2" color="primary" @click="closeDeleteConfirm">
                キャンセル
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <!-- メイン画面 -->
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0">
          住民情報は下の表を参照してください。条件を指定することで一覧から絞り込むことができます。
        </p>
        <v-row>
          <v-col cols="6" md="3">
            <v-text-field v-model="fa_name" label="施設名" disabled>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="nameFilterValue"
              label="氏名"
              :placeholder="config.PLACEHOLDER_NAME"
              append-icon="mdi-magnify"
              clearable
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="nameKanaFilterValue"
              label="氏名カナ"
              :placeholder="config.PLACEHOLDER_KANA_NAME"
              append-icon="mdi-magnify"
              clearable
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col v-if="type === 'SC'" cols="12" md="3">
            <v-select
              v-model="schYearFilterValue"
              :items="[...schYears]"
              label="学年"
              item-text="formatted_sch_year"
              item-value="sch_year"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="type === 'SC'" cols="12" md="3">
            <v-select
              v-model="schClsFilterValue"
              :items="[...schClasses]"
              label="組"
              item-text="formatted_sch_cls"
              item-value="sch_cls"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="type === 'VU' || type === 'SU'" cols="12" md="3">
            <v-select
              v-model="issueDateFilterValue"
              :items="[...issueDates]"
              label="発行日"
              item-text="formatted_issue_date"
              item-value="issue_date"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="type === 'SC'" cols="12" md="3">
            <v-select
              v-model="issueDateFilterValue"
              :items="[...issueDates]"
              label="発行日"
              item-text="formatted_issue_date"
              item-value="issue_date"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="type === 'SC'" cols="12" md="3">
            <v-select
              v-model="expirationDateFilterValue"
              :items="[...expirationDates]"
              v-if="type === 'SC'"
              label="有効期限"
              item-text="formatted_expiration_date"
              item-value="expiration_date"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="type === 'VU' || type === 'SU'" cols="12" md="6">
            <v-text-field
              v-model="addressFilterValue"
              label="現住所"
              :placeholder="config.PLACEHOLDER_ADDRESS"
              append-icon="mdi-magnify"
              clearable
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="type === 'VU' || type === 'SU'">
          <v-col cols="12" md="3">
            <v-text-field
              v-model="birthdayFilterValue"
              label="生年月日"
              :placeholder="config.PLACEHOLDER_BIRTH"
              append-icon="mdi-magnify"
              clearable
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="sexFilterValue"
              :items="[...statusList[1]]"
              label="性別"
              item-text="status_text"
              item-value="status_id"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-row v-if="type === 'VU' || type === 'SU'">
          <v-col cols="12" md="3">
            <v-select
              v-model="iodinePossessionFilterValue"
              :items="[...statusList[0]]"
              label="安定ヨウ素剤所持状況"
              item-text="status_text"
              item-value="status_id"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="pregrancyPossibilityFilterValue"
              :items="[...statusList[0]]"
              label="妊娠有無"
              item-text="status_text"
              item-value="status_id"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="requiredConsiderationFilterValue"
              label="要配慮の理由"
              :placeholder="config.PLACEHOLDER_INPUT"
              append-icon="mdi-magnify"
              clearable
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="type === 'VU' || type === 'SU'">
          <v-col cols="12" md="9">
            <v-text-field
              v-model="remarkfilterValues"
              label="備考"
              :placeholder="config.PLACEHOLDER_INPUT"
              append-icon="mdi-magnify"
              clearable
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider class="mb-1"></v-divider>
      </v-container>
      <top-operation-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :sort-by="sort.by"
        item-key="qrdisp_id"
        locale="ja-jp"
        loading-text="読込中"
        no-data-text="データがありません。"
        show-select
        must-sort
        class="fixedWidth"
        disp-mode="nowrap"
      >
        <template v-slot:[`item.sch_year`]="{ item }">
          {{ item.sch_year }}年
        </template>
        <template v-slot:[`item.year`]="{ item }">{{ item.year }}年</template>
        <template v-slot:[`item.sch_cls`]="{ item }"
          >{{ item.sch_cls }}組</template
        >
        <template v-slot:[`item.name_kanji`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="text-truncate d-inline-block"
                style="max-width: 720px"
              >
                {{ item.name_kanji }}
              </span>
            </template>
            <span> {{ item.name_kanji }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.name_kana`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="text-truncate d-inline-block"
                style="max-width: 720px"
              >
                {{ item.name_kana }}
              </span>
            </template>
            <span> {{ item.name_kana }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.address`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="text-truncate d-inline-block"
                style="max-width: 720px"
              >
                {{ item.address }}
              </span>
            </template>
            <span> {{ item.address }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.remarks`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="text-truncate d-inline-block"
                style="max-width: 720px"
              >
                {{ item.remarks }}
              </span>
            </template>
            <span> {{ item.remarks }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.issue_date`]="{ item }">
          {{ formatDate(item.issue_date) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            small
            class="mx-2"
            color="primary"
            @click="editItem(item)"
            :disabled="!hasUpdateAuthorityByItem(item)"
          >
            編集
          </v-btn>
          <v-btn
            small
            class="mx-2"
            color="primary"
            @click="deleteConfirm(item)"
            :disabled="
              !hasDeleteAuthorityByItem(item, !screen.hasDeleteAuthority)
            "
          >
            削除
          </v-btn>
        </template>
      </top-operation-data-table>
      <v-row>
        <v-col>
          <v-btn
            :disabled="this.selected.length == 0"
            @click="openPdf"
            class="mx-2"
            color="primary"
            >印刷</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn class="mx-2" color="primary" @click="closePage">戻る</v-btn>
        </v-col>
      </v-row>
    </v-sheet>
    <v-overlay :value="overlay" opacity="1" color="white" z-index="2147483647">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import QrCodeFacilityType from "@/plugins/qr-code-facility-type";
Vue.use(QrCodeFacilityType);
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { createFacilityQrCodePdf } from "@/js/repository/pdf-creator/facilityQrCodePdfCreator";
import { createSchoolQrCodePdf } from "@/js/repository/pdf-creator/schoolQrCodePdfCreator";
import messageUtils from "@/mixins/message-utils";
import config from "@/js/const";
import { ErrorTodoMessages } from "@/js/constants/error-messages";
import cloneDeep from "lodash/cloneDeep";
const considerationPersonInfoRepository = RepositoryFactory.get(
  "considerationPersonInfo"
);
const studentInfoRepository = RepositoryFactory.get("studentInfo");
const vulFacilityEvagrpRepository = RepositoryFactory.get("vulFacilityEvagrp");
const UUID = require("uuidjs");

export default {
  mixins: [messageUtils],

  components: {
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },
  data: () => ({
    loading: false,
    overlay: false,
    dialog: false,
    dialogDelete: false,
    dialogDeleteConfirm: false,
    cantSaveFlag: false,
    group_id: "",
    group_name: "",
    type: "",
    fa_name: "",
    selected: [],
    detailItem: [],
    items: [],
    editedIndex: -1,
    editedItem: {
      year: "",
      sch_year: "",
      sch_cls: "",
      att_num: "",
      name_kanji: "",
      name_kana: "",
      address: "",
      birthday: "",
      sex: "",
      iodine_possession: "",
      pregrancy_possibility: "",
      required_consideration: "",
      remarks: ""
    },
    defaultItem: {
      year: "",
      sch_year: "",
      sch_cls: "",
      att_num: "",
      name_kanji: "",
      name_kana: "",
      address: "",
      birthday: "",
      sex: "",
      iodine_possession: "",
      pregrancy_possibility: "",
      required_consideration: "",
      remarks: ""
    },
    statusList: cloneDeep(STATUS_LIST),

    schYears: [],
    schClasses: [],
    issueDates: [],
    sexDates: [],
    iodinePossessionDates: [],
    pregrancyPossibilityDates: [],
    expirationDates: [],
    nameFilterValue: "",
    nameKanaFilterValue: "",
    schYearFilterValue: "",
    schClsFilterValue: "",
    issueDateFilterValue: "",
    expirationDateFilterValue: "",
    addressFilterValue: "",
    birthdayFilterValue: "",
    sexFilterValue: "",
    iodinePossessionFilterValue: "",
    pregrancyPossibilityFilterValue: "",
    requiredConsiderationFilterValue: "",
    remarkfilterValues: "",
    facilityType: null,
    screen: null,
    rules: {
      // 必須項目チェック
      required: value => !!value || ErrorTodoMessages.ERWE40004,
      // 数字チェック
      numberCheck: value => !isNaN(value) || ErrorTodoMessages.ERWE40008,
      // 年度チェック
      yearCheck: value =>
        /^[0-9]{4}$/.test(value) || ErrorTodoMessages.ERWE40015(4),
      // 英数字チェック
      alphanumericCheck: value =>
        /^[0-9a-zA-Z]+$/.test(value) || ErrorTodoMessages.ERWE40039,
      // 生年月日形式字チェック
      birthdayCheck: value => {
        return (
          /^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/.test(value) ||
          value == "" ||
          ErrorTodoMessages.ERWE40044
        );
      }
    },

    config: config // 共通プレースホルダ
  }),

  computed: {
    headers() {
      // リクエストパラメタtypeの値で分岐
      if (this.type === "SC") {
        return this.headerSchool();
      } else {
        return this.headerFacility();
      }
    },

    isNew() {
      return this.editedIndex === -1 ? true : false;
    },

    formTitle() {
      return this.isNew ? "住民情報の登録" : "住民情報の編集";
    },

    saveBtnText() {
      return this.isNew ? "登録" : "更新";
    },
    sort() {
      /**
       * /一覧をソートした状態で一覧のチェックボックスにチェックを入れると
       * ソート状態が解除されるエラーに対応
       * */
      return {
        by: ["qrdisp_id"]
      };
    }
  },

  watch: {
    $route: "initialize"
  },

  mounted() {
    this.pageTitle(this.screen.screenTitle);
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      // 読み込みGUI表示
      this.overlay = true;
      this.loading = true;

      this.facilityType = this.$facilityType.factory(
        this.$route.name === "school-qr-code-issue"
      );

      // 画面情報
      const issueScreenId = this.facilityType.issueScreenId();

      // 画面権限取得
      this.screen = this.$screenOperationAuthority(
        issueScreenId,
        issueScreenId
      );

      // クエリから情報取得
      this.type = this.$route.query.type;
      this.group_id = this.$route.query.group_id;

      let screenId = ""; // ルートにある画面ID
      let screenName = ""; // ルートにある画面名
      // 画面によって画面のヘッダーとルート情報を初期化
      if (this.type === "SC") {
        screenId = "SF0606";
        screenName = "school-qr-code-group";
      } else {
        screenId = "SF0603";
        screenName = "facility-qr-code-group";
      }
      await vulFacilityEvagrpRepository
        .getFacilityEvaGrpList(screenId)
        .then(response => {
          const targetFacilityEvaInfo = response.data.results.find(
            ele => ele.manage_grp_id === this.group_id
          );

          this.group_name = targetFacilityEvaInfo.manage_grp_name;
          this.fa_name = targetFacilityEvaInfo.fa_name;
          this.year = targetFacilityEvaInfo.year;
        })
        .catch(e => {
          this.handleError(e, screenId, screenName);
        });

      // 一覧取得,検索項目と一覧の初期化
      await this.getItems();

      // 読み込みGUI非表示
      this.overlay = false;
      this.loading = false;
    },

    // 一覧取得,検索項目と一覧の初期化
    async getItems() {
      // 一覧を初期化
      this.items = [];

      // セレクトボックス検索項目の変数の初期化
      this.schYears = [];
      this.schClasses = [];
      this.issueDates = [];
      this.sexDates = [];
      this.iodinePossessionDates = [];
      this.pregrancyPossibilityDates = [];
      this.expirationDates = [];

      if (this.type === "SC") {
        // 学校の場合
        let students;
        await studentInfoRepository
          .getStudents(this.group_id, "SF0606")
          .then(response => {
            students = response.data.results;
            students.forEach(s => {
              // 発行単位名追加
              s.group_name = this.group_name;
              // 施設（学校）名追加
              s.fa_name = this.fa_name;
              // 学年検索に用いるデータづくり
              this.schYears.push({
                sch_year: s.sch_year,
                formatted_sch_year: `${s.sch_year}年`
              });
              // 組検索に用いるデータづくり
              this.schClasses.push({
                sch_cls: s.sch_cls,
                formatted_sch_cls: `${s.sch_cls}組`
              });
              // 発行日検索に用いるデータづくり
              this.issueDates.push({
                issue_date: s.issue_date,
                formatted_issue_date: this.formatDate(s.issue_date)
              });
              // 有効期限の計算 & 発行日のフォーマット変更
              s.formatted_expiration_date = moment(
                this.formatDate(s.issue_date)
              )
                .add(parseInt(s.expiration_date) - 1, "d")
                .format("YYYY/MM/DD");
              // 有効期限検索に用いるデータづくり
              this.expirationDates.push({
                expiration_date: s.formatted_expiration_date,
                formatted_expiration_date: s.formatted_expiration_date
              });
            });
            this.items = students;
          })
          .catch(e => {
            this.handleError(e, "SF0606", "school-qr-code-group");
          });
      } else if (this.type === "VU" || this.type === "SU") {
        // 要配慮者施設の場合
        let considerationPersons;
        await considerationPersonInfoRepository
          .getConsiderationPersons(this.group_id, "SF0603")
          .then(response => {
            considerationPersons = response.data.results;
            considerationPersons.forEach(cp => {
              // 発行単位名追加
              cp.group_name = this.group_name;
              // 発行日検索に用いるデータづくり
              this.issueDates.push({
                issue_date: cp.issue_date,
                formatted_issue_date: this.formatDate(cp.issue_date)
              });
            });
            // 性別データ追加
            this.sexDates.push(
              {
                sex_id: "1",
                sex_text: "男"
              },
              {
                sex_id: "2",
                sex_text: "女"
              },
              {
                sex_id: "3",
                sex_text: "どちらでもない"
              }
            );
            // 安定ヨウ素剤所持状況データ追加
            this.iodinePossessionDates.push(
              {
                iodinePossession_id: "0",
                iodinePossession_text: "無"
              },
              {
                iodinePossession_id: "1",
                iodinePossession_text: "有"
              }
            );
            // 妊娠有無データ追加
            this.pregrancyPossibilityDates.push(
              {
                pregrancyPossibility_id: "0",
                pregrancyPossibility_text: "無"
              },
              {
                pregrancyPossibility_id: "1",
                pregrancyPossibility_text: "有"
              }
            );
            this.detailItem = considerationPersons;
            this.createDetailTableDataList(this.detailItem);
            this.items = this.detailItem;
          })
          .catch(e => {
            this.handleError(e, "SF0603", "facility-qr-code-group");
          });
      }
    },

    /* 検索詳細テーブルデータ作成 */
    createDetailTableDataList(data) {
      data.forEach((item, i) => {
        // 性別
        data[i].sex =
          item.sex == "1"
            ? "男"
            : item.sex == "2"
            ? "女"
            : item.sex == "3"
            ? "どちらでもない"
            : "";
        // 生年月日(形式：YYYYMMDD)
        (data[i].birthday =
          item.birthday == ""
            ? ""
            : this.$moment(item.birthday, "YYYYMMDD").format("YYYY/MM/DD")),
          // 安定ヨウ素剤所持
          (data[i].iodine_possession =
            item.iodine_possession == ""
              ? ""
              : item.iodine_possession == "0"
              ? "無"
              : "有"),
          // 妊娠有無
          (data[i].pregrancy_possibility =
            item.pregrancy_possibility == ""
              ? ""
              : item.pregrancy_possibility == "0"
              ? "無"
              : "有");
      });
    },

    headerSchool() {
      return [
        {
          text: "発行単位",
          value: "group_name"
        },
        {
          text: "生徒ID",
          align: " d-none",
          value: "student_id"
        },
        {
          text: "No",
          value: "qrdisp_id"
        },
        {
          text: "年度",
          value: "year"
        },
        {
          text: "学校名",
          value: "fa_name"
        },
        {
          text: "学年",
          value: "sch_year",
          filter: this.schYearFilter
        },
        {
          text: "組",
          value: "sch_cls",
          filter: this.schClsFilter
        },
        {
          text: "出席番号",
          value: "att_num"
        },
        {
          text: "氏名",
          value: "name_kanji",
          filter: this.nameFilter
        },
        {
          text: "氏名カナ",
          value: "name_kana",
          filter: this.nameKanaFilter
        },
        {
          text: "備考",
          value: "remarks"
        },
        {
          text: "発行日",
          value: "issue_date",
          filter: this.issueDateFilter
        },
        {
          text: "有効期限",
          value: "formatted_expiration_date",
          filter: this.expirationDateFilter
        },
        {
          text: "操作",
          value: "actions",
          sortable: false
        }
      ];
    },

    headerFacility() {
      return [
        {
          text: "発行単位",
          value: "group_name"
        },
        {
          text: "No",
          value: "qrdisp_id"
        },
        {
          text: "氏名",
          value: "name_kanji",
          filter: this.nameFilter
        },
        {
          text: "氏名カナ",
          value: "name_kana",
          filter: this.nameKanaFilter
        },
        {
          text: "現住所",
          value: "address",
          filter: this.addressFilter
        },
        {
          text: "生年月日",
          value: "birthday",
          filter: this.birthDayFilter
        },
        {
          text: "性別",
          value: "sex",
          filter: this.sexFilter,
          align: "center"
        },
        {
          text: "安定ヨウ素剤所持状況",
          value: "iodine_possession",
          filter: this.tabletsStatusFilter,
          align: "center"
        },
        {
          text: "妊娠有無",
          value: "pregrancy_possibility",
          filter: this.pregnancyFilter,
          align: "center"
        },
        {
          text: "要配慮の理由",
          value: "required_consideration",
          filter: this.vulReasonFilter,
          align: "center"
        },
        {
          text: "備考",
          value: "remarks",
          filter: this.remarkFilter
        },
        {
          text: "発行日",
          value: "issue_date",
          filter: this.issueDateFilter
        },
        {
          text: "操作",
          value: "actions",
          sortable: false
        }
      ];
    },

    registerItem() {
      this.judgeRegisterInfo();
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;

      // 性別
      this.editedItem.sex = this.convSex(item.sex);
      // 安定ヨウ素剤所持状況
      this.editedItem.iodine_possession = this.convEysNone(
        item.iodine_possession
      );
      // 妊娠有無
      this.editedItem.pregrancy_possibility = this.convEysNone(
        item.pregrancy_possibility
      );

      this.judgeRegisterInfo();
    },

    // 性別
    convSex(value) {
      if (value == "男") {
        value = "1";
      } else if (value == "女") {
        value = "2";
      } else if (value == "どちらでもない") {
        value = "3";
      }
      return value;
    },

    // 有無判定
    convEysNone(value) {
      if (value == "無") {
        return "0";
      } else if (value == "有") {
        return "1";
      } else {
        return "";
      }
    },

    deleteConfirm(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItem() {
      // 読み込みGUI表示
      this.overlay = true;
      this.loading = true;

      // 削除
      if (this.type === "SC") {
        this.clearMessage();
        await studentInfoRepository
          .updateStudent(
            {
              student_id: this.items[this.editedIndex].student_id,
              year: this.items[this.editedIndex].year,
              sch_year: this.items[this.editedIndex].sch_year,
              sch_cls: this.items[this.editedIndex].sch_cls,
              att_num: this.items[this.editedIndex].att_num,
              name_kanji: this.items[this.editedIndex].name_kanji,
              name_kana: this.items[this.editedIndex].name_kana,
              remarks: this.items[this.editedIndex].remarks,
              delete_flg: "1",
              hash: this.items[this.editedIndex].hash
            },
            "SF0606"
          )
          .then(response => {
            this.handleSuccess(response);
          })
          .catch(e => {
            this.handleUpdateError(e);
          });
      } else if (this.type === "VU" || this.type === "SU") {
        this.clearMessage();
        await considerationPersonInfoRepository
          .updateConsiderationPerson(
            {
              cns_person_id: this.items[this.editedIndex].cns_person_id,
              //fa_name: this.items[this.editedIndex].fa_name,
              year: this.items[this.editedIndex].year,
              name_kanji: this.items[this.editedIndex].name_kanji,
              name_kana: this.items[this.editedIndex].name_kana,
              address: this.items[this.editedIndex].address,
              birthday: this.convDate(this.items[this.editedIndex].birthday),
              sex: this.convSex(this.items[this.editedIndex].sex),
              iodine_possession: this.convEysNone(
                this.items[this.editedIndex].iodine_possession
              ),
              pregrancy_possibility: this.convEysNone(
                this.items[this.editedIndex].pregrancy_possibility
              ),
              required_consideration: this.items[this.editedIndex]
                .required_consideration,
              remarks: this.items[this.editedIndex].remarks,
              delete_flg: "1",
              hash: this.items[this.editedIndex].hash
            },
            "SF0603"
          )
          .then(response => {
            this.handleSuccess(response);
          })
          .catch(e => {
            this.handleUpdateError(e);
          });
      }

      this.closeDeleteConfirm();

      // 一覧取得,検索項目と一覧の初期化
      await this.getItems();

      // 読み込みGUI非表示
      this.overlay = false;
      this.loading = false;
    },

    closeEdit() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$refs.form.reset();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    openDeleteConfirm() {
      this.dialogDelete = false;
      this.dialogDeleteConfirm = true;
    },

    closeDeleteConfirm() {
      this.dialogDeleteConfirm = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });

      this.$refs.form?.reset(); // 編集画面の有効性チェック初期化
    },

    async save() {
      if (this.$refs.form.validate() === false) {
        return;
      }
      // 読み込みGUI表示
      this.overlay = true;
      this.loading = true;
      if (this.isNew) {
        // 新規登録API
        await this.registerInfo();
      } else {
        // 更新API
        await this.updateInfo();
      }
      // 先にダイアログを閉じる
      this.closeEdit();

      // 一覧取得,検索項目と一覧の初期化
      await this.getItems();

      // 読み込みGUI非表示
      this.overlay = false;
      this.loading = false;
    },

    async registerInfo() {
      if (this.type === "SC") {
        // 学校のパターン
        await studentInfoRepository
          .registerStudent(
            {
              student_id: UUID.generate(),
              manage_grp_id: this.group_id,
              fa_name: this.fa_name,
              year: this.editedItem.year,
              sch_year: this.editedItem.sch_year,
              sch_cls: this.editedItem.sch_cls,
              att_num: this.editedItem.att_num,
              name_kanji: this.editedItem.name_kanji,
              name_kana: this.editedItem.name_kana,
              remarks: this.editedItem.remarks
            },
            "SF0606"
          )
          .then(response => {
            this.handleSuccess(response);
          })
          .catch(e => {
            this.handleCreateError(e);
          });
      } else if (this.type === "VU" || this.type === "SU") {
        // 要配慮者施設のパターン
        // 新規登録API呼び出し
        await considerationPersonInfoRepository
          .registerConsiderationPerson(
            {
              cns_person_id: UUID.generate(),
              manage_grp_id: this.group_id,
              fa_name: this.fa_name,
              year: this.editedItem.year,
              name_kanji: this.editedItem.name_kanji,
              name_kana: this.editedItem.name_kana,
              address: this.editedItem.address,
              birthday: this.convDate(this.editedItem.birthday),
              sex: this.editedItem.sex,
              iodine_possession: this.editedItem.iodine_possession,
              pregrancy_possibility: this.editedItem.pregrancy_possibility,
              required_consideration: this.editedItem.required_consideration,
              remarks: this.editedItem.remarks,
              qrcode_class: this.type
            },
            "SF0603"
          )
          .then(response => {
            this.handleSuccess(response);
          })
          .catch(e => {
            this.handleCreateError(e);
          });
      }
    },
    async updateInfo() {
      if (this.type === "SC") {
        // 学校のパターン
        // 更新API呼び出し
        this.clearMessage();
        await studentInfoRepository
          .updateStudent(
            {
              student_id: this.items[this.editedIndex].student_id,
              year: this.editedItem.year,
              sch_year: this.editedItem.sch_year,
              sch_cls: this.editedItem.sch_cls,
              att_num: this.editedItem.att_num,
              name_kanji: this.editedItem.name_kanji,
              name_kana: this.editedItem.name_kana,
              remarks: this.editedItem.remarks || "", //NULLが更新処理対象外なのでNULLの場合""に変換処理
              delete_flg: "0",
              hash: this.items[this.editedIndex].hash
            },
            "SF0606"
          )
          .then(response => {
            this.handleSuccess(response);
          })
          .catch(e => {
            this.handleUpdateError(e);
          });
      } else if (this.type === "VU" || this.type === "SU") {
        // 要配慮者施設のパターン
        // 更新API呼び出し
        this.clearMessage();
        await considerationPersonInfoRepository
          .updateConsiderationPerson(
            {
              cns_person_id: this.items[this.editedIndex].cns_person_id,
              year: "",
              name_kanji: this.editedItem.name_kanji || "",
              name_kana: this.editedItem.name_kana || "",
              address: this.editedItem.address || "",
              birthday: this.convDate(this.editedItem.birthday),
              sex: this.editedItem.sex || "",
              iodine_possession: this.editedItem.iodine_possession || "",
              pregrancy_possibility:
                this.editedItem.pregrancy_possibility || "",
              required_consideration:
                this.editedItem.required_consideration || "",
              remarks: this.editedItem.remarks || "", //NULLが更新処理対象外なのでNULLの場合""に変換処理,
              delete_flg: "0",
              hash: this.items[this.editedIndex].hash
            },
            "SF0603"
          )
          .then(response => {
            this.handleSuccess(response);
          })
          .catch(e => {
            this.handleUpdateError(e);
          });
      }
    },

    /**
     * YYYY/MM/DD -> YYYYMMDDに変換する
     */
    convDate(date) {
      const formattedDate = this.$moment(date);
      if (formattedDate.isValid()) {
        return formattedDate.format("YYYYMMDD");
      }
      return "";
    },

    /**
     * YYYYMMDD -> YYYY/MM/DDに変換する
     */
    formatDate(date) {
      const formattedDate = this.$moment(date);
      if (formattedDate.isValid()) {
        return formattedDate.format("YYYY/MM/DD");
      }
      return "";
    },

    // 氏名フィルター
    nameFilter(value) {
      if (!this.nameFilterValue) {
        return true;
      }
      return value.includes(this.nameFilterValue);
    },

    // 氏名カナフィルター
    nameKanaFilter(value) {
      if (!this.nameKanaFilterValue) {
        return true;
      }
      return value.includes(this.nameKanaFilterValue);
    },
    // 学年フィルター
    schYearFilter(value) {
      if (!this.schYearFilterValue) {
        return true;
      }
      return value === this.schYearFilterValue;
    },

    // 組フィルター
    schClsFilter(value) {
      if (!this.schClsFilterValue) {
        return true;
      }
      return value === this.schClsFilterValue;
    },

    // 発行日フィルター
    issueDateFilter(value) {
      if (!this.issueDateFilterValue) {
        return true;
      }
      return value === this.issueDateFilterValue;
    },

    // 有効期限フィルター
    expirationDateFilter(value) {
      if (!this.expirationDateFilterValue) {
        return true;
      }
      return value === this.expirationDateFilterValue;
    },
    /**
     * カスタムフィルター (性別)
     */
    sexFilter(value) {
      if (!this.sexFilterValue) {
        return true;
      }
      return this.convSex(value).includes(this.sexFilterValue);
    },
    /**
     * カスタムフィルター (生年月日)
     */
    birthDayFilter(value) {
      if (!this.birthdayFilterValue) {
        return true;
      }
      return value.includes(this.birthdayFilterValue);
    },
    /**
     * カスタムフィルター (現住所)
     */
    addressFilter(value) {
      if (!this.addressFilterValue) {
        return true;
      }
      return value.includes(this.addressFilterValue);
    },
    /**
     * カスタムフィルター (要配慮者理由)
     */
    vulReasonFilter(value) {
      if (!this.requiredConsiderationFilterValue) {
        return true;
      }
      return value.includes(this.requiredConsiderationFilterValue);
    },
    /**
     * カスタムフィルター (妊娠有無)
     */
    pregnancyFilter(value) {
      if (!this.pregrancyPossibilityFilterValue) {
        return true;
      }
      return this.convEysNone(value).includes(
        this.pregrancyPossibilityFilterValue
      );
    },
    /**
     * カスタムフィルター (安定ヨウ素剤所持有無)
     */
    tabletsStatusFilter(value) {
      if (!this.iodinePossessionFilterValue) {
        return true;
      }
      return this.convEysNone(value).includes(this.iodinePossessionFilterValue);
    },
    /**
     * カスタムフィルター (備考)
     */
    remarkFilter(value) {
      if (!this.remarkfilterValues) {
        return true;
      }
      return value.includes(this.remarkfilterValues);
    },

    openPdf() {
      //発行単位情報
      const GROUP_INFO = {
        manage_grp_id: this.group_id,
        manage_grp_name: this.group_name
      };
      if (this.type === "SC") {
        // 学校の場合
        createSchoolQrCodePdf(this.selected, GROUP_INFO);
      } else if (this.type === "VU" || this.type === "SU") {
        // 要配慮者施設の場合
        createFacilityQrCodePdf(this.selected, this.group_name);
      }
    },

    closePage() {
      this.$router.push({
        path: this.facilityType.groupPath()
      });
    },

    judgeRegisterInfo() {
      if (this.type === "SC") {
        // 学校の場合
        if (
          !this.yearValid(this.editedItem.year) ||
          !this.schClsValid(this.editedItem.sch_cls) ||
          !this.schYearValid(this.editedItem.sch_year) ||
          !this.attNumValid(this.editedItem.att_num) ||
          !this.editedItem.name_kanji ||
          !this.editedItem.name_kana
        ) {
          this.cantSaveFlag = true;
        } else {
          this.cantSaveFlag = false;
        }
      } else if (this.type === "VU" || this.type === "SU") {
        // 要配慮者施設の場合
        if (
          this.nameKanjiValid(this.editedItem.name_kanji) ||
          this.birthDayValid(this.editedItem.birthday)
        ) {
          this.cantSaveFlag = true;
        } else {
          this.cantSaveFlag = false;
        }
      }
    },
    // 名前（漢字）チェックによる更新ボタン活性化有無
    nameKanjiValid(value) {
      return !value;
    },
    // 年度チェックによる更新ボタン活性化有無
    yearValid(year) {
      return !!year && !isNaN(year) && /^[0-9]{4}$/.test(year);
    },
    // 学年チェックによる更新ボタン活性化有無
    schYearValid(schYear) {
      return !!schYear && !isNaN(schYear);
    },
    // 組チェックによる更新ボタン活性化有無
    schClsValid(sch_cls) {
      return !!sch_cls && /^[0-9a-zA-Z]+$/.test(sch_cls);
    },
    // 出席番号チェックによる更新ボタン活性化有無
    attNumValid(attNum) {
      return !!attNum && !isNaN(attNum);
    },
    // 生年月日の形式チェック
    birthDayValid(birthDay) {
      return !(
        /^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/.test(
          birthDay
        ) || birthDay == ""
      );
    }
  }
};

const STATUS_LIST = Object.freeze([
  [
    {
      status_id: "0",
      status_text: "無"
    },
    {
      status_id: "1",
      status_text: "有"
    }
  ],
  [
    {
      status_id: "1",
      status_text: "男"
    },
    {
      status_id: "2",
      status_text: "女"
    },
    {
      status_id: "3",
      status_text: "どちらでもない"
    }
  ]
]);
</script>
